module.exports = __webpack_public_path__ + "img/blog-01-770x420.58c77a18.jpg";